import { Box, Container, Typography } from "@mui/material";
import React from "react";
import TargetLead from "../../assets/svgs/target-leads.svg";
import DoneIcon from "@mui/icons-material/Done";
import WorldGlobe from "../../assets/svgs/world-globe.svg";
import CostPrice from "../../assets/svgs/cost-price.svg";
import useMediaQuery from "@mui/material/useMediaQuery";

const detailsCards = [
  {
    img: TargetLead,
    mainText: "Get more leads",
    subText:
      "Our expert marketers market your product over various platforms attracting buyers that are looking for similar equipment.",
    p1: "Listing is published and advertised globally",
    p2: "Access to an analytics dashboard",
    p3: "Smart marketing",
  },
  {
    img: WorldGlobe,
    mainText: "Worldwide visibility",
    subText:
      "Machinery Planet has visitors, buyers from all over the world. All they are looking for is heavy equipment.",
    p1: "Dealers",
    p2: "Auctioneers",
    p3: "Manufacturers",
  },
  {
    img: CostPrice,
    mainText: "We help you sell more",
    subText:
      "Our inventory is automatically updated. Our powerful dashboard gives detailed analytics to help you grow your business.",
    p1: "Reach new customers",
    p2: "Automatic Updates",
    p3: "Powerful dashboard",
  },
];

function WhySell() {
  const mobMatch = useMediaQuery("(max-width:600px)");

  const Card = (details) => {
    return (
      <Box
        sx={{
          width: { xs: "100%", sm: "384px" },
          height: { xs: "306", sm: "354px" },
          borderRadius: { xs: "8px", sm: "4px" },
          background: { xs: "#fff", sm: "" },
          padding: { xs: "24px 16px", sm: "32px" },
          display: "flex",
          flexFlow: "column",
          rowGap: { xs: "16px", sm: "32px" },
          boxShadow:
            "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        }}
      >
        <img src={details.img} width="58px" height="58px" alt="why-card-icon" />
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "22px",
              lineHeight: "26px",
            }}
            variant="h3"
          >
            {details.mainText}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              lineHeight: "20px",
              color: "#616161",
            }}
            variant="body2"
          >
            {details.subText}{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexFlow: "column",
            rowGap: "8px",
          }}
        >
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              color: "text.primary",
            }}
            variant="subtitle2"
          >
            {
              <DoneIcon
                sx={{
                  color: "text.primary",
                  width: "13px",
                  height: "13px",
                  fontWeight: "bold",
                  marginRight: "3px",
                }}
              />
            }
            {details.p1}{" "}
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              color: "text.primary",
            }}
            variant="subtitle2"
          >
            {
              <DoneIcon
                sx={{
                  color: "text.primary",
                  width: "13px",
                  height: "13px",
                  fontWeight: "bold",
                  marginRight: "3px",
                }}
              />
            }
            {details.p2}{" "}
          </Typography>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "14px",
              lineHeight: "20px",
              color: "text.primary",
            }}
            variant="subtitle2"
          >
            {
              <DoneIcon
                sx={{
                  color: "text.primary",
                  width: "13px",
                  height: "13px",
                  fontWeight: "bold",
                  marginRight: "3px",
                }}
              />
            }
            {details.p3}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Container
      disableGutters={true}
      sx={{ marginY: { xs: "16px", sm: "72px" } }}
    >
      {!mobMatch && (
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 700,
            fontSize: "32px",
            lineHeight: "36px",
          }}
          variant="h2"
        >
          We find buyers for your machinery
        </Typography>
      )}
      <Box
        sx={{
          marginTop: { sm: "56px" },
          display: "flex",
          flexFlow: { xs: "column", sm: "row" },
          columnGap: { sm: "24px" },
          rowGap: { xs: "16px", sm: "0px" },
          justifyContent: "center",
        }}
      >
        {detailsCards.map((detail) => {
          return Card(detail);
        })}
      </Box>
    </Container>
  );
}

export default WhySell;
